import { render, staticRenderFns } from "./comapny.vue?vue&type=template&id=e73b7e7c&"
import script from "./comapny.vue?vue&type=script&lang=js&"
export * from "./comapny.vue?vue&type=script&lang=js&"
import style0 from "./comapny.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports